import {
  SET_MEMBER_DATA,
  SET_MEMBERS_DATA,
  SET_MEMBER_COUNT,
  SET_MEMBERS,
  SET_MEMBERS_COUNT
} from "../../actions/types/types";

const initState = {
  member: {},
  members: [],
  allMembers: undefined,
  allMembersCount: undefined,
  memberCount: 0
};

const MemberReducer = (state = initState, action) => {
  switch (action.type) {
    case SET_MEMBER_DATA:
      return {
        ...state,
        member: action.payload.data
      };
    case SET_MEMBER_COUNT:
      return {
        ...state,
        memberCount: action.payload.data
      };

    case SET_MEMBERS_DATA:
      return {
        ...state,
        members: action.payload.data
      };
    case SET_MEMBERS:
      return {
        ...state,
        allMembers: action.payload.data
      };
    case SET_MEMBERS_COUNT:
      return {
        ...state,
        allMembersCount: action.payload.data
      };

    default:
      return { ...state };
  }
};

export default MemberReducer;
